import * as React from 'react';
import { ActionPointInfo, awaitLoad, Controller, IActionPointInfo, MainMenu, Menu, Param, StateManager, Toolbar } from '@tencent/workbench';
import DocsConfig from '@tencent/docs-config';
import { ToolbarFileMenuConfig } from '@src/slide/infrastructure/module/dependent/config/config-manager-constants';
import { defaultMenu, config, TOOLBAR_ITEMS } from './config';
import { INSERT_IFRAME_LOADED_FLAG } from '@framework/workbench/const/addon-const';
import { InsertAddonFeature } from './insert-addon-feature';
import { ActionType } from '@src/framework/editor/src/js/constants/common-action-type';

@Controller({
    menuItems: defaultMenu,
    toolbarItems: TOOLBAR_ITEMS,
})
export class InsertAddonController {
    constructor(
        private readonly stateManager: StateManager,
        private readonly feature: InsertAddonFeature,
    ) {
    }

    @Menu(config.id, 'onClick')
    public onClick() {
        return false;
    }

    @Menu(config.id, 'shouldHide')
    @Toolbar(config.id, 'shouldHide')
    public shouldHide() {
        const res = this.stateManager.getValue(INSERT_IFRAME_LOADED_FLAG);
        return !res || !DocsConfig.getInstance().getConfig(ToolbarFileMenuConfig.insertAddon);
    }

    @Menu(config.id, 'shouldDisabled')
    @Toolbar(config.id, 'shouldDisabled')
    public shouldDisabled(@ActionPointInfo() info: IActionPointInfo) {
        return this.feature.shouldDisabled(config.id);
    }


    @Toolbar(config.id, 'dropdownContent')
    public getInsertTableDropdownContent() {
        return <MainMenu align="left" name={config.id} mode="menu"/>;
    }

    @Toolbar(config.id, 'onDropdownVisibleChange')
    public onDropdownVisibleChange(visible: boolean) {
        this.feature.updateDropdownVisible(visible, config.id);
    }

    @Menu('addon-insert-:menuid', 'onClick')
    @awaitLoad()
    public onAddonClick(@Param('menuid') menuId: string) {
        this.feature.getMenuManager()?.toolbarMenu()
            ?.callback('TOOLBAR', ActionType.INSERT_IFRAME_ITEM, menuId);
    }
}
